// dependencies.
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'

/************************/
/*                      */
/*    Search Heading    */
/*                      */
/************************/

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

// main component.
const FilterStatus = ({
  label,
  defaultValue = '',
  onStatusFilter = () => {},
  placeholder = 'Estado',
}) => {
  // contexts.
  // hooks.
  const { isMobile, isTablet } = useDimensions()

  const statusOptions = [
    { name: 0, label: 'Pendientes' },
    { name: 1, label: 'Asignadas' },
    { name: 2, label: 'Realizadas' },
    { name: 3, label: 'Canceladas' },
  ]

  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //
  // return content.

  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <Input
        isMobile={isMobile}
        defaultValue={defaultValue}
        options={statusOptions}
        name="status"
        iconL="bookmark"
        placeholder={placeholder}
        onChange={(value) => {
          if (value === null || value === undefined || value === '' || value === 'undefined') {
            onStatusFilter('')
            return
          }
          onStatusFilter(Number(value))
        }}
      />
    </Wrapper>
  )
}

export default FilterStatus
